export const mobileBreakpoint = 980; //px
export const nextQuestionTimeout = 3; // seconds
export const numberOfQuestionsPerGame = 20;
export const recaptchaSiteKey = "6LcwfcoZAAAAAPYuNTeru4dsTtSTasc1LRrOyfhi";